import { render, staticRenderFns } from "./step-edit.vue?vue&type=template&id=215d484a"
import script from "./step-edit.vue?vue&type=script&lang=ts"
export * from "./step-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports